import {useMutation} from "react-query";
import {RemoveGroupMemberCommand} from "../../models/group";
import groupMemberService from "../../services/GroupMemberService";

export default function useRemoveGroupMember() {
   return useMutation((request: RemoveGroupMemberCommand) => groupMemberService.remove(request));
}